import classNames from 'classnames';
import React from 'react';
import styles from "./Typography.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const DEFAULT_VARIANT = 'p';
export const validHeadlines = new Set(['h1', 'h2', 'h3', 'h4', 'h5']);
export const validLegalVariants = new Set(['p', 'strong', 'h5']);
export const validMediumVariants = new Set(['p', 'span']);
export const validVariants = new Set(['p', 'strong', 'span', 'h1', 'h2', 'h3', 'h4', 'h5']);

/**
 * custom styled Typography
 *
 * create a component with default styling's for these html tags:
 * 'p', 'span', 'strong', 'h1', 'h2', 'h3', 'h4', 'h5'
 *
 * @param variant this is the type of the typography like a paragraph or headline
 * @param htmlTag the html tag of the typography like a h1 or span (variant will be used as fallback)
 * @param legal property is only valid on validLegalVariants
 * @param medium property is only valid on validMediumVariants
 * @param className optional overwriting class properties
 * @param margin defines bottom margin of element
 * @param children
 * @param rest
 *
 */
export const Typography = ({
  variant = DEFAULT_VARIANT,
  htmlTag,
  legal,
  medium,
  className,
  margin = true,
  children,
  ...rest
}) => {
  const customStyles = classNames(styles.reset, styles[`typography-${variant}`], validLegalVariants.has(variant) && legal && styles.legal, validMediumVariants.has(variant) && medium && styles.medium, margin && styles.margin, className);
  const HtmlTag = htmlTag ?? variant;
  return /*#__PURE__*/_jsx(HtmlTag, {
    className: customStyles,
    ...rest,
    children: children
  });
};